import api from './api';

// gym-api responses are enveloped as { success, message, data, error } —
// these helpers unwrap to the `data` payload for callers.

export async function getSubscriptionStatus() {
  const res = await api.get('/payments/status');
  return res.data.data;
}

export async function createOrder() {
  const res = await api.post('/payments/create-order');
  return res.data.data;
}

export async function verifyPayment(payload) {
  const res = await api.post('/payments/verify', payload);
  return res.data.data;
}

export async function getInvoice() {
  const res = await api.get('/payments/invoice');
  return res.data.data;
}

export async function reportPaymentFailed(payload) {
  const res = await api.post('/payments/failed', payload);
  return res.data.data;
}
